import { observer } from "mobx-react";
import React from "react";
import { PositionedSpinner } from "../../../../../../../components/ui/PositionedSpinner";
import { SingleForm } from "../../../../../../change/forms/singleFormModel/SingleForm_view";
import { ProjectProcessRolesSidebarModel } from "./ProjectProcessRolesSidebar_model";

export interface ProjectProcessRolesSidebarProps {
  model: ProjectProcessRolesSidebarModel;
}

export const ProjectProcessRolesSidebar: React.FC<ProjectProcessRolesSidebarProps> = observer(({ model }) => {
  if (model.isLoading) return <PositionedSpinner />;

  return (
    <div className="container-fluid">
      <SingleForm model={model.formModel} />
    </div>
  );
});
